var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "23.2 19.77 29.6 32.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_11",
    "data-name": "Artboard \\u2013 11",
    clipPath: "url(#clip-Artboard_11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-335.65 -141.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(186.606 23.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M193.861,137.243H180.228a7.985,7.985,0,0,0,0,15.97h8.054a.55.55,0,0,0,0-1.1h-8.054a6.886,6.886,0,0,1,0-13.772h13.628a6.882,6.882,0,0,1,3.52,12.8.549.549,0,0,0,.562.944,7.981,7.981,0,0,0-4.077-14.844Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M191.744,152.566l-5.3,5.3-.075-.822a2.1,2.1,0,0,0-1.9-2.267,1.373,1.373,0,0,0-.192-.009,2.115,2.115,0,0,0-2.089,1.907l-.439,4.784v.007a.549.549,0,0,0,.5.593h.01a.547.547,0,0,0,.59-.5l.439-4.784a1.006,1.006,0,0,1,.994-.91h.124a1.025,1.025,0,0,1,.874,1.156v.013l.184,2.088a.551.551,0,0,0,.36.468.525.525,0,0,0,.188.034.55.55,0,0,0,.388-.161l6.134-6.134a1.31,1.31,0,0,1,1.852,1.852l-3.944,3.943a.552.552,0,0,0,0,.778l1.461,1.46a3.586,3.586,0,0,1,0,5.063l-2.338,2.338a.549.549,0,0,0,.388.938.543.543,0,0,0,.376-.151l2.338-2.338a4.685,4.685,0,0,0,0-6.617l-1.072-1.072,3.555-3.555a2.408,2.408,0,0,0-3.406-3.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M183.083,144.14a.4.4,0,0,0,.308-.123.541.541,0,0,0,.107-.42l-.026-.321a.908.908,0,0,0-.587-.842,3.305,3.305,0,0,0-1.225-.25,2.046,2.046,0,0,0-1.794.9,3.736,3.736,0,0,0-.546,2.111,4.063,4.063,0,0,0,.376,1.8,2.079,2.079,0,0,0,2,1.176,3.338,3.338,0,0,0,1.558-.369.5.5,0,0,0,.252-.417q0-.015,0-.03a.4.4,0,0,0-.407-.393.969.969,0,0,0-.365.1l-.108.045a2.1,2.1,0,0,1-.853.19c-.986,0-1.486-.707-1.486-2.075s.513-2.153,1.408-2.153a1.853,1.853,0,0,1,.86.211h.008l.054.416v.006a.464.464,0,0,0,.466.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M187.114,148.141a.489.489,0,0,0,.489-.489V143.14h1.114a.432.432,0,1,0,0-.864h-3.2a.432.432,0,0,0,0,.864h1.112v4.512a.489.489,0,0,0,.485.489Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M191.132,147.793l.3-1.09h2.077l.3,1.089a.474.474,0,0,0,.468.342.486.486,0,0,0,.48-.484.512.512,0,0,0-.032-.16l-1.312-4.484c-.164-.579-.411-.784-.945-.784-.427,0-.75.133-.944.784l-1.31,4.477a.533.533,0,0,0-.033.167.484.484,0,0,0,.484.484A.476.476,0,0,0,191.132,147.793Zm.518-1.876.772-2.832h.1l.774,2.832Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIcon);
export default __webpack_public_path__ + "static/media/cta_icon.e7924095322bdfb7f18b0c475409fe17.svg";
export { ForwardRef as ReactComponent };